import { AuthService } from '../auth/AuthService';
import { ApiBack } from '../axios-config';

export interface IConstructiveProject {
    quantidade_etapas_previstas?: number,
    quantidade_etapas_executadas?: number,
    historico_construtivo?: string,
    metodo_construtivo?: string,
    uuid?: string,
    id_tipo?: string,
    id_barragem?: string,
    id_empresa?: string
}

const create = async (data: IConstructiveProject, uuid: string): Promise<IConstructiveProject | Error > => {
    await AuthService.verify();
    
    try {
        const token = await AuthService.getAccessToken();
        const formData = new FormData();
        
        // Object.entries(data).forEach(([key, value]) => {
        //     if (key === 'quantidade_etapas_previstas' || key === 'quantidade_etapas_executadas'||
        //     key === 'historico_construtivo' || key === 'metodo_construtivo' ) {
        //         formData.append(key, value.replace(/"/g, '')); 
        //     } else if (key === 'file' && value instanceof File) {
        //         formData.append(key, value); 
        //     } else{
        //         formData.append(key, JSON.stringify(value)); 
        //     }
        // });        
        const response = await ApiBack.post(`./projetoconstrutivo?uuid=${uuid}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data',
                Authorization: `${token}` 
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao criar arquivo');
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar arquivo');
        }
    }
};

const update = async (data: IConstructiveProject, uuid: string): Promise<IConstructiveProject | Error > => {

    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();
        
        const response = await ApiBack.put(`./projetoconstrutivo?uuid=${uuid}`, data, {
            headers: {
                Authorization: `${token}` , 
                'Content-Type': 'multipart/form-data',
            }
        });

        if (response.data) {
            return response.data;
        }

        return new Error('Erro ao criar arquivo');
    } catch (error: any) {
        if (error.response && error.response.data && error.response.data.error && error.response.data.message) {
            return new Error(error.response.data.message);
        } else {
            return new Error((error as { message: string }).message || 'Erro ao criar arquivo');
        }
    }
};

const get = async(uuid: string, download: boolean): Promise<IConstructiveProject | Error> => {
    await AuthService.verify();

    try {
        const token = await AuthService.getAccessToken();

        const response = await ApiBack.get(`./projetoconstrutivo?uuid=${uuid}&download=${download}`, {
            headers: {
                Authorization: `${token}`
            }
        });

        if (response.data) {
            return response.data;
        }
        return new Error('Erro ao buscar registros de Projetos Construtivos.');
    } catch (error) {
        return new Error((error as { message: string }).message || 'Erro na requisição de buscar de Projetos Construtivos.');
    }
};

export const ConstructiveProjectServices = {
    create,
    update,
    get,
};